import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'
import { covertBoolStringToBool } from 'app/utils/strings/helpers'
import { isOwnerDecisionNotifyTeamSettingEnabled } from 'config/features'

type ApplicationAttributes = Record<string, unknown>

export const parseOwnerDecisionNotifyTeamSetting = (
  application: ApplicationAttributes = {},
): boolean => {
  const value =
    application[
      applicationsAttributesIDs.shareApplicationOwnerDecisionNotifyTeam
    ]
  return covertBoolStringToBool(value)
}

interface BuildOwnerDecisionNotifyTeamSettingPayloadArgs {
  isAccountPremier: boolean
  enabled: boolean
}

export const buildOwnerDecisionNotifyTeamSettingPayload = ({
  isAccountPremier,
  enabled,
}: BuildOwnerDecisionNotifyTeamSettingPayloadArgs): Record<string, string> => {
  if (!isOwnerDecisionNotifyTeamSettingEnabled(isAccountPremier)) {
    return {}
  }

  return {
    [applicationsAttributesIDs.shareApplicationOwnerDecisionNotifyTeam]:
      enabled.toString(),
  }
}
